import * as React from 'react'
import { CheckIcon } from 'primitives/icons'

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  enabled: boolean
  onClick: () => void
}

export const Chip = ({
  ref,
  text,
  enabled,
  onClick,
  ...rest
}: ChipProps & {
  ref?: React.Ref<HTMLButtonElement | null>
}) => {
  return (
    // oxlint-disable-next-line react/button-has-type
    <button
      {...rest}
      ref={ref}
      onClick={onClick}
      style={{ background: enabled ? `#E5DEF5` : '', borderColor: enabled ? `#E5DEF5` : '' }}
      className={
        'text-14 bg-cf-white visited:bg-cf-white flex h-8 cursor-pointer flex-row items-center justify-center gap-1.5 rounded-full border border-[#E5DEF5] px-3 font-medium active:border-[#E5DEF5] active:bg-[#E5DEF5] sm:hover:border-[#E5DEF5] sm:hover:bg-[#E5DEF5]'
      }
    >
      {enabled ? <CheckIcon className="size-3.5" /> : null}
      <p className="whitespace-nowrap">{text}</p>
    </button>
  )
}

Chip.displayName = 'Chip'
